import React, { Component } from 'react';
import { Modal, Typography, Box, Checkbox, FormControlLabel, Button, Tooltip, Grid } from '@mui/material';
import Base from '../Base';
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ImageIcon from '@mui/icons-material/Image';
import { styled } from "@mui/system";

const DocumentBox = styled(Box)({
    border: "1px solid #ccc",
    borderRadius: "10px",
    padding: "15px",
    background: "#f5f5f5",
    marginBottom: "20px",
    transition: "all 0.3s ease",
    width: "150px",
    height: "150px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "&:hover": {
        transform: "scale(1.02)",
        boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
    },
});

const DocumentImage = styled("img")({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
});

class DocumentModal extends Base {
    constructor(props) {
        super(props);


        this.state = {
            data: [],
            loading: false,
        };


    }

    componentDidUpdate(prevProps) {

        if (this.props.open && !prevProps.open) {

            this.LoadDataOnOpen();
        }
    }

    LoadDataOnOpen() {

        console.log(this.props);

        const { archives, archiveIds } = this.props;

        let data = archives.map(item => ({ ...item }));

        if (data) {

            data.map((archive, index) => {

                if (archiveIds.some(e => e == archive.id))
                    archive.selected = true;
            });

            this.setState({ data: data });
        }

        console.log("DocumentItem.LoadDataOnOpen : data : ", this.state.data);
    }

    handleDocumentSelection = (event) => {

        const checked = event.target.checked;
        const index = event.target.getAttribute("data-index");

        console.log('Checked:', checked);

        let { data } = this.state;

        data[index].selected = checked;

        this.setState({ data });
    };


    handleSave = () => {

        const { onArchiveSaved, documentItemId } = this.props;
        const { data } = this.state;

        var selectedIds = data.filter(e => e.selected).map(e => e.id);

        this.setState({ data: [] });

        onArchiveSaved(documentItemId, selectedIds);
    }

    render() {

        const { open, onClose } = this.props;
        const { data } = this.state;


        return (
            <Modal open={open} onClose={this.onClose}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 320, maxWidth: 600, borderRadius: '10px', textAlign: 'right' }}>
                    <Typography variant="h5" gutterBottom>
                        انتخاب اسناد
                    </Typography>


                    <Grid container spacing={3} mt={2} justifyContent="center">
                        {data.map((document, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={index} sx={{ margin: "25px" }}>
                                <DocumentBox>
                                    {document.contentType.startsWith("image") ? (
                                        <Box sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "100%",
                                            height: "100%",
                                            background: "#fff",
                                            borderRadius: "10px",
                                        }}>

                                            <ImageIcon fontSize="large" />

                                        </Box>

                                    ) : (
                                        <Box sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "100%",
                                            height: "100%",
                                            background: "#fff",
                                            borderRadius: "10px",
                                        }}>

                                            <InsertDriveFileIcon fontSize="large" />

                                        </Box>
                                    )}
                                    <Box sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        flexDirection: "column",
                                        width: "100%",
                                    }}>

                                        <Grid item>
                                            <input type="checkbox" data-index={index} value={document.id}
                                                onChange={this.handleDocumentSelection} checked={document.selected}
                                            />
                                        </Grid>

                                        <Tooltip title={document.description} arrow>
                                            <Box
                                                sx={{
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    textOverflow: "ellipsis",
                                                    cursor: "default",
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        textAlign: "right",
                                                        fontWeight: "bold",
                                                        marginBottom: "4px",
                                                        marginTop: "16px",
                                                    }}
                                                >
                                                    {document.title}
                                                </Typography>
                                            </Box>
                                        </Tooltip>
                                    </Box>
                                </DocumentBox>
                            </Grid>
                        ))}

                    </Grid>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button onClick={onClose} sx={{ mr: 2 }}>
                            بستن
                        </Button>
                        <Button variant="contained" color="primary" onClick={this.handleSave}>
                            ذخیره
                        </Button>
                    </Box>
                </Box>
            </Modal>
        );
    }
}

export default DocumentModal;
